import Vue from 'vue';
import 'swiper/dist/css/swiper.css';

const VueAwesomeSwiper = typeof window !== 'undefined' ? require('vue-awesome-swiper/dist/ssr') : '';

if (typeof window !== 'undefined') {
  Vue.use(VueAwesomeSwiper);
}
